import { render, staticRenderFns } from "./order-list.vue?vue&type=template&id=84681b42&scoped=true&"
import script from "./order-list.vue?vue&type=script&lang=js&"
export * from "./order-list.vue?vue&type=script&lang=js&"
import style0 from "./order-list.vue?vue&type=style&index=0&id=84681b42&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84681b42",
  null
  
)

export default component.exports